import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import MoviequizImg from "../../assets/event-images/moviequiz.jpg";

const movieQuiz = {
  image: MoviequizImg,
  description:
    "Dive into the enchanting realm of South Indian cinema with the 'Kollywood Quiz'! From timeless classics to contemporary blockbusters, test your Tamil cinema expertise in a friendly and entertaining competition. We celebrate the magic of Kollywood together. Don't miss this chance to showcase your love for Tamil cinema!",
  type: "Non Technical Event",
  eventName: "Movies Mania",
  dateTime: "Mar 01, 11:00AM - 12:30PM",
  venue: "IT-444",
  rules: [
    "Each team will consist of 2-3 members.",
    "The task is to connect the pictures and identify the movie, actor, or concept they represent.",
    "The winners will be determined by the team that correctly guesses the highest number of movies.",
    "Cheating, use of mobile phones (except for buzzers or meme creation), or external help is strictly prohibited.",
    "The quizmaster's decision is final in case of disputes.",
  ],

  firstprize: 1000,
  secondprize: 500,
  thirdprize: 0,
  contact: [
    {
      name: "Akilesh S",
      phoneNo: "7904836440",
    },
    {
      name: "Meganathan S",
      phoneNo: "9442977311",
    },
  ],
};

const MovieQuiz = () => {
  return <SingleEventPage eventDetails={movieQuiz} />;
};

export default MovieQuiz;
